












import Vue from "vue";
// @ts-ignore
import CookieLaw from "vue-cookie-law";
import FooterBottomMenu from "./FooterBottomMenu.vue";
import FooterMain from "./FooterMain.vue";

export default Vue.extend({
  name: "Footer",
  components: {
    FooterMain,
    FooterBottomMenu,
    CookieLaw
  }
});
